<template>
  <div class="currency-record">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="状态">
        <Select v-model="searchCondition.status" class="com-width" clearable>
          <Option v-for="item in refundStatus" :value="item.key" :key="item.key">{{item.value}}</Option>
        </Select>
      </FormItem>
      <FormItem label="发起退款时间">
        <DatePicker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px"
          @on-change="onDateRange"
          :editable="false"
          clearable
        ></DatePicker>
      </FormItem>
      <br />
      <FormItem label="订单号">
        <Input
          v-model="searchCondition.order_number"
          placeholder="请输入订单号"
          style="width:200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入订单用户手机号"
          style="width:200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/orderRefund"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="order_number"
        method="get"
      ></Grid>
    </div>
  </div>
</template>

<script>
import { RefundStatus } from "@/utils/enums";

export default {
  name: "currency-record",
  data() {
    return {
      refundStatus: RefundStatus.getOptions(),
      searchCondition: {
        status: "",
        refund_start: "",
        refund_end: "",
        order_number: "",
        mobile: "",
        init() {
          this.status = "";
          this.refund_start = "";
          this.refund_end = "";
          this.order_number = "";
          this.mobile = "";
        }
      },
      tableColumns: [
        { title: "退款单编号", key: "refund_num", align: "center", minWidth: 200 },
        { title: "支付单编号", key: "payment_num", align: "center", minWidth: 200 },
        { title: "订单编号", key: "order_num", align: "center", minWidth: 200 },
        { title: "交易流水号", key: "trade_no", align: "center", minWidth: 200 },
        { title: "用户手机号", key: "mobile", align: "center", minWidth: 200 },
        { title: "退款金额", key: "send_back_fee", align: "center", minWidth: 90 },
        { title: "状态", key: "status_name", align: "center", minWidth: 90 },
        { title: "创建时间", key: "created_at", align: "center", minWidth: 150 },
        { title: "退款时间", key: "updated_at", align: "center", minWidth: 150 }
      ]
    };
  },
  methods: {
    // on event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    },
    onDateRange(range) {
      this.searchCondition.refund_start = range[0];
      this.searchCondition.refund_end = range[1];
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.send_back_fee = this.$pub.calcPrice(i.send_back_fee);
        i.status_name = RefundStatus.getValue(i.status);
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.updated_at =
          i.status == 2 ? this.$pub.timestampToTime(i.updated_at) : "";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>